import React from "react";
import { Pane, TextInput, Paragraph, Tooltip, IconButton, InfoSignIcon } from 'evergreen-ui';

const VersionForm = (props) => {

  return (
    <Pane 
      display="flex" 
      flexDirection="row" 
      alignItems="center" 
      justifyContent="flex-start" 
      paddingY={12}
    >
      <Paragraph 
        marginRight={12} 
        marginBottom={8}
        size={300}
      >
        New EPUB Version:
      </Paragraph>
      <TextInput 
        width="50%"
        marginBottom={8}
        placeholder="1.0"
        value={props.version} 
        onChange={e => {
          props.updateVersion(e.target.value);
        }}
      />
      <Tooltip content="Not sure? Just leave this as-is!">
        <IconButton icon={InfoSignIcon} appearance="minimal" marginBottom={8} />
      </Tooltip>
    </Pane>
  );
}

export default VersionForm;